const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const isMobile = Odigeo.SessionScope.flow === 'mobile';

module.exports = createWidgetFactory({
    name: 'baggage_selector',
    viewClass: isMobile ? require('./view.mobile') : require('./view.desktop'),
    methods: {
        open() {
            this.open();
        },
        update(data, caller) {
            this.update(data, caller);
        },
    },
});
